export const VIDEO_SOUND = {
  SOURCES: [
    {
      src: "https://www.asos-video.com/video/upload/eo_6.5,so_0.5/f_webm/Flicker%20logo%20(1)_haahbv.webm",
      type: "video/webm",
    },
    {
      src: "https://www.asos-video.com/video/upload/eo_6.5,so_0.5/f_webm/Flicker%20logo%20(1)_haahbv.mp4",
      type: "video/mp4",
    },
  ],
  ASPECT_RATIO: 16 / 9,
  DESCRIPTION: "Topshop Topman choose your journey",
} as const;

export const VIDEO_NO_SOUND = {
  SOURCES: [
    {
      src: "https://www.asos-video.com/video/upload/eo_6/f_webm/TSTM%20flicker%20anim_dnljti.webm",
      type: "video/webm",
    },
    {
      src: "https://www.asos-video.com/video/upload/eo_6/TSTM%20flicker%20anim_dnljti.mp4",
      type: "video/mp4",
    },
  ],
  ASPECT_RATIO: 16 / 9,
  DESCRIPTION: "Topshop Topman choose your journey",
} as const;
